module.exports = __webpack_public_path__ + "img/1.2bd63e7b.jpg";